import { throwError as observableThrowError, Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { API_URLS } from '../utils/api_url.util';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { UserRoleModel } from '../model/user_role.model';
import { YearGroupModel } from '../model/year-group.model';
import { UserModel } from '../model/user.model';
import { TraineeLogbookAuditModel } from '../model/trainee-logbook-audit.model';
import { TrainerLogbookAuditModel } from '../model/trainer-logbook-audit.model';
import { UserRoleAppModuleModel } from '../model/user_role_module.model';
import { AppModuleModel } from '../model/app_module.model';
import { AuthUserModel } from '../model/auth_user.model';
import { SMSVerifyResponseModel } from '../model/sms_verify_response.model';
import { TraineeOverviewModel } from '../model/trainee_overview.model';
import { catchError, map } from 'rxjs/operators';
import { UserAddResultModel } from '../model/user_add_result.model';
import { SuggestedTrainerModel } from '../model/suggested_trainer.model';
import { TraineeRotationsModel } from '../model/trainee_rotations.model';
import { TrainerOverviewModel } from '../model/trainer_overview.model';
import { BulkUserModel } from '../model/bulk-user-model';

@Injectable()
export class AuthService {
	constructor(private http: HttpClient) {}

	isLoggedIn: boolean = false;
	authUser: AuthUserModel = null;

	// store the URL so we can redirect after logging in
	redirectUrl: string;

	getIsUserTrainer() {
		let isTrainerId = this.authUser.roles.indexOf('Supervisor');
		if (isTrainerId > 0) return true;

		return false;
	}

	login(userName: string, password: string): Observable<AuthUserModel> {
		/*
       let clientId:string='1880957B-A51E-4363-87D0-19CE2EECAD4D';
       let clientSecret='37974EF9-D82A-4E9C-929D-B6490964670A';


     let body = "username="+`${userName}`+"&password="+`${password}`+"&client_id="+`${clientId}`+"&client_secret="+`${clientSecret}`+"&grant_type=password"+"&is_twitter_digit_auth=false";
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-form-urlencoded' });
    let options = { headers: headers };
*/
		let login = { Username: userName, Password: password };
		let body = JSON.stringify(login);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http.post(API_URLS.API_LOGIN_PASSWORD, body, options).pipe(
			catchError(handleError),
			map((res) => {
				this.isLoggedIn = false;
				let user: AuthUserModel = <AuthUserModel>res;
				this.authUser = user;

				if (user) {
					console.log(user);
					this.isLoggedIn = true;
					localStorage.setItem('authUser', JSON.stringify(this.authUser));
				}

				return user;
			})
		);
		return items$;
	}

	getIsLoggedIn(): boolean {
		let user: AuthUserModel = JSON.parse(localStorage.getItem('authUser'));

		if (user) {
			this.authUser = user;
			this.isLoggedIn = true;
		} else {
			this.isLoggedIn = false;
		}

		return this.isLoggedIn;
	}

	logout() {
		this.isLoggedIn = false;
	}

	resetUser() {
		localStorage.setItem('authUser', null);
		this.authUser = null;
		this.isLoggedIn = false;
	}

	/////////////////////////////////////////////////////////////////////////////////////////

	getUserHasAccessRight(userId: string, moduleId: number): Observable<boolean> {
		let items$ = this.http
			.get<boolean>(API_URLS.API_GET_HAS_USER_ACCESS_RIGHT_TO_APP_MODULE + `/${userId}` + `/${moduleId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getSuggestedTrainersByStatus(status: string): Observable<SuggestedTrainerModel[]> {
		let items$ = this.http
			.get<SuggestedTrainerModel[]>(API_URLS.API_GET_SUGGESTED_TRAINERS_BY_STATUS + `/${status}`)
			.pipe(catchError(handleError));
		return items$;
	}

	takeSuggestedTrainerAction(item: SuggestedTrainerModel): Observable<UserAddResultModel> {
		let items$ = this.http
			.get<UserAddResultModel>(
				API_URLS.API_POST_TAKE_SUGGESTED_USER_ACTION +
					`/${item.Id}` +
					`/${item.ApprovedByUserId}` +
					`/${item.Status}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getUserRoles(userId: string): Observable<string[]> {
		let items$ = this.http.get<string[]>(API_URLS.API_GET_USER_ROLES + `/${userId}`).pipe(catchError(handleError));
		return items$;
	}

	getUserDetail(id: string): Observable<UserModel> {
		let items$ = this.http.get<UserModel>(API_URLS.API_GET_USER_DETAIL + `/${id}`).pipe(catchError(handleError));
		return items$;
	}

	updateUserRoles(userId: string, roles: string[]): Observable<string[]> {
		let items$ = this.http
			.put<string[]>(API_URLS.API_UPDATE_USER_ROLES + `/${userId}` + '/roles', roles)
			.pipe(catchError(handleError));
		return items$;
	}

	addUserRoleModule(item: UserRoleAppModuleModel): Observable<UserRoleAppModuleModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<UserRoleAppModuleModel>(API_URLS.API_ADD_USER_ROLE_APP_MODULE, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	removeUserRoleModule(item: UserRoleAppModuleModel): Observable<UserRoleAppModuleModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.get<UserRoleAppModuleModel>(API_URLS.API_REMOVE_USER_ROLE_APP_MODULE + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getUserRoleAppModules(id: string): Observable<Array<UserRoleAppModuleModel>> {
		let items$ = this.http
			.get<Array<UserRoleAppModuleModel>>(API_URLS.API_GET_USER_ROLE_APP_MODULES + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getRoles(): Observable<Array<UserRoleModel>> {
		let items$ = this.http.get<Array<UserRoleModel>>(API_URLS.API_GET_ROLES).pipe(catchError(handleError));
		return items$;
	}

	addRole(item: UserRoleModel): Observable<UserRoleModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http.post<UserRoleModel>(API_URLS.API_ADD_ROLE, body, options).pipe(catchError(handleError));
		return items$;
	}

	sendStudentLogbookProcedurePendingReminder(item: TraineeLogbookAuditModel[]): Observable<boolean> {
		let body = JSON.stringify({ Alerts: item });
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<boolean>(API_URLS.API_SMS_NOTIFY_SEND_STUDENT_LOGBOOK_PROCEDURE_PENDING_REMINDER, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	sendSupervisorLogbookProcedurePendingReminder(item: TrainerLogbookAuditModel[]): Observable<boolean> {
		let body = JSON.stringify({ Alerts: item });
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<boolean>(API_URLS.API_SMS_NOTIFY_SEND_SUPERVISOR_LOGBOOK_PROCEDURE_PENDING_REMINDER, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainees(): Observable<Array<UserModel>> {
		let items$ = this.http.get<Array<UserModel>>(API_URLS.API_GET_TRAINEES).pipe(catchError(handleError));
		return items$;
	}

	getTrainerTraineesAtHospitalFaculty(userId: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_SUPERVISOR_STUDENTS_AT_HOSPITAL_FACULTY + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineesByFaculty(facultyId: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_TRAINEES_BY_FACULTY + `/${facultyId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineesByScheduledRotationHospital(hospitalId: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_TRAINEES_BY_SCHEDULED_ROTATION_HOSPITAL + `/${hospitalId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineesByPostingHospital(hospitalId: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_TRAINEES_BY_POSTING_HOSPITAL + `/${hospitalId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getYearGroups(): Observable<Array<YearGroupModel>> {
		let items$ = this.http.get<Array<YearGroupModel>>(API_URLS.API_GET_YEAR_GROUPS).pipe(catchError(handleError));
		return items$;
	}

	findUserByUsername(username: string): Observable<UserModel> {
		username = username.replace(/\//g, '-'); // replace forward slash in resident Id eg IM/56/7/M to IM-56-7-M

		console.log(username);

		let items$ = this.http
			.get<UserModel>(API_URLS.API_GET_USER_BY_USERNAME + `/${username}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainers(hospitalId: string): Observable<Array<UserModel>> {
		let items$ = this.http
			.get<Array<UserModel>>(API_URLS.API_GET_TRAINERS + `/${hospitalId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getAllTrainers(): Observable<Array<UserModel>> {
		let items$ = this.http.get<Array<UserModel>>(API_URLS.API_GET_ALL_TRAINERS).pipe(catchError(handleError));
		return items$;
	}

	getTraineeOverview(id: string): Observable<Array<TraineeOverviewModel>> {
		let items$ = this.http
			.get<Array<TraineeOverviewModel>>(API_URLS.API_GET_TRAINEE_OVERVIEW + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerOverview(id: string): Observable<Array<TrainerOverviewModel>> {
		let items$ = this.http
			.get<Array<TrainerOverviewModel>>(API_URLS.API_GET_TRAINER_OVERVIEW + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeRotationDetails(studentId: string): Observable<TraineeRotationsModel> {
		let items$ = this.http
			.get<TraineeRotationsModel>(API_URLS.API_GET_TRAINEE_ROTATION_DETAILS + `/${studentId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	verifyUserPhoneNumber(phoneNumber: string): Observable<SMSVerifyResponseModel> {
		let items$ = this.http
			.get<SMSVerifyResponseModel>(API_URLS.API_VERIFY_USER_PHONE + `/${phoneNumber}`)
			.pipe(catchError(handleError));
		return items$;
	}

	verifySMSCode(userId: string, smsCode: string): Observable<UserModel> {
		let items$ = this.http
			.get<UserModel>(API_URLS.API_VERIFY_SMS_CODE + `/${userId}` + `/${smsCode}`)
			.pipe(catchError(handleError));
		return items$;
	}

	sendSMSVerifyCode(userId: string): Observable<number> {
		let items$ = this.http.get<number>(API_URLS.API_SEND_VERIFY_CODE + `/${userId}`).pipe(catchError(handleError));
		return items$;
	}

	resetUserPasswordWithSmsCode(userId: string, smsCode: string, password: string): Observable<number> {
		let body = JSON.stringify({ UserId: userId, SMSCode: smsCode, Password: password });
		console.log(body);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<number>(API_URLS.API_RESET_USER_PASSWORD_WITH_SMS, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineesLogbookAudit(): Observable<Array<TraineeLogbookAuditModel>> {
		let items$ = this.http
			.get<Array<TraineeLogbookAuditModel>>(API_URLS.API_GET_TRAINEE_LOGBOOK_AUDIT)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainersLogbookAudit(): Observable<Array<TrainerLogbookAuditModel>> {
		let items$ = this.http
			.get<Array<TrainerLogbookAuditModel>>(API_URLS.API_GET_TRAINER_LOGBOOK_AUDIT)
			.pipe(catchError(handleError));
		return items$;
	}

	getSystemUsers(): Observable<Array<UserModel>> {
		let items$ = this.http.get<Array<UserModel>>(API_URLS.API_GET_SYSTEM_USERS).pipe(catchError(handleError));
		return items$;
	}

	getAppModules(): Observable<Array<AppModuleModel>> {
		let items$ = this.http.get<Array<AppModuleModel>>(API_URLS.API_GET_APP_MODULES).pipe(catchError(handleError));
		return items$;
	}

	getUserAppModules(userId: string): Observable<Array<AppModuleModel>> {
		let items$ = this.http
			.get<Array<AppModuleModel>>(API_URLS.API_GET_USER_APP_MODULES + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	addUser(item: BulkUserModel): Observable<UserAddResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<UserAddResultModel>(API_URLS.API_ADD_USER_SYSTEM_USER, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	addBulkUser(item: Array<BulkUserModel>): Observable<Array<BulkUserModel>> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<Array<BulkUserModel>>(API_URLS.API_ADD_BULK_TRAINEE, body, options)
			.pipe(catchError(handleError));
		return items$;
	}
	/*
    addUserTrainee(item:UserModel): Observable<UserModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let id=item.Id;

    let items$ = this.http

      .post<UserModel>(API_URLS.API_ADD_USER_TRAINEE,body,options)

      .pipe(         catchError(handleError)       )
      return items$;


    }

    addUserSystemUser(item:UserModel): Observable<UserModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let id=item.Id;

    let items$ = this.http

      .post<UserModel>(API_URLS.API_ADD_USER_SYSTEM_USER,body,options)
      .pipe(         catchError(handleError)       )
      return items$;


    }
    */

	updateUser(item: UserModel): Observable<UserModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http.post<UserModel>(API_URLS.API_UPDATE_USER, body, options).pipe(catchError(handleError));
		return items$;
	}

	updateUserTrainer(item: UserModel): Observable<UserModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<UserModel>(API_URLS.API_UPDATE_USER_TRAINER, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	resetSystemUserPassword(item: any): Observable<UserModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<UserModel>(API_URLS.API_RESET_SYSTEM_USER_PASSWORD, body, options)
			.pipe(catchError(handleError));
		return items$;
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
